export enum UserType {
    Employee = 1,
    Customer = 2
}
